export const update = (state, payload) => ({
    ...state,
    ...payload,
});
